import styled from 'styled-components';

export default styled.div`
  display: grid;
  align-content: center;
  justify-content: ${({ justify }) => justify || 'start'};
  padding: ${({padding}) => padding || '1rem 0'};
`;
